export const productTypes = {
  CUSTOM: 'Custom',
  READY: 'Ready to ship'
}